var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FFEED5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3187_560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8337 26.82L34.247 25.9933L30.5003 17.1666L26.7537 26.0066L17.167 26.82L24.447 33.1266L22.2603 42.5L30.5003 37.5266L38.7403 42.5L36.567 33.1266L43.8337 26.82ZM30.5003 35.0333L25.487 38.06L26.8203 32.3533L22.3937 28.5133L28.2337 28.0066L30.5003 22.6333L32.7803 28.02L38.6203 28.5266L34.1937 32.3666L35.527 38.0733L30.5003 35.0333Z",
    fill: "#FBB040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3187_560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14.5 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.198d6a7ebf77a444d18e1d6dbac093c6.svg";
export { ForwardRef as ReactComponent };